import Cookies from 'js-cookie'
import { isLocal, setCurrency, setLanguage } from '~/util'
import {
  getCountry,
  getCurrency,
  getLanguage,
  setCountry,
} from '~/util/cookies'

/**
 * Fetches geo data and sets it as a cookie.
 */
export default async ({ $sentry, store }) => {
  if (window.Weglot) {
    const weglot = window.Weglot

    weglot.on('initialized', () => {
      const existingLanguage = getLanguage()
      if (existingLanguage) {
        weglot.switchTo(existingLanguage)
      } else {
        const lang = weglot.getCurrentLang()
        setLanguage(lang)
      }

      weglot.on('languageChanged', newLang => {
        setLanguage(newLang)
      })
    })
  }

  if (!store.state.flags.enable_multi_currency_and_language) return

  if (!isLocal()) {
    const data = await fetch('/api/geo/locate')
      .then(res => res.json())
      .catch(e => null)

    if (data) {
      if (!getCurrency() && !!data.currency) {
        setCurrency(data.currency)
      }

      if (!getCountry()) {
        setCountry(data.country)
      }
    }
  }
}
